/* SABEH theme JS — AJAX cart drawer */
(function () {
  'use strict';

  const body = document.body;
  const drawer = () => document.getElementById('CartDrawer');

  function openCart() { body.classList.add('cart-open'); drawer()?.setAttribute('aria-hidden', 'false'); }
  function closeCart() { body.classList.remove('cart-open'); drawer()?.setAttribute('aria-hidden', 'true'); }

  // Re-render the parts of the page that depend on the cart, using the Section Rendering API.
  async function refreshCart(openAfter) {
    try {
      const cart = await (await fetch('/cart.js')).json();
      updateCounts(cart);
      await sabehGoalsUpdate(cart);  // await so reward sync completes before re-render
      await rerenderDrawer();
      if (openAfter) openCart();
    } catch (e) { console.warn('SABEH cart refresh failed', e); }
  }

  function updateCounts(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    document.querySelectorAll('[data-cart-total]').forEach(el => {
      el.textContent = (cart.total_price / 100).toLocaleString('ar-EG');
    });
    const foot = document.querySelector('[data-cart-foot]');
    if (foot) foot.hidden = cart.item_count === 0;
    const sgbCart = document.getElementById('sgb-cart');
    if (sgbCart) sgbCart.hidden = cart.item_count === 0;
    updateDiscountRow(cart);
  }

  // Keep the "الخصم" row in the drawer in sync with the cart's applied discount(s)
  function updateDiscountRow(cart) {
    const row = document.querySelector('[data-cart-discount]');
    if (!row) return;
    if (cart.total_discount > 0) {
      row.hidden = false;
      const amtEl = row.querySelector('[data-discount-amount]');
      if (amtEl) amtEl.textContent = (cart.total_discount / 100).toLocaleString('ar-EG');
      const labelEl = row.querySelector('[data-discount-label]');
      const title = cart.cart_level_discount_applications && cart.cart_level_discount_applications[0]
        ? cart.cart_level_discount_applications[0].title : '';
      if (labelEl) labelEl.textContent = 'الخصم' + (title ? ' (' + title + ')' : '');
    } else {
      row.hidden = true;
    }
  }

  // Pull fresh line-item HTML by re-rendering the cart-drawer section.
  async function rerenderDrawer() {
    try {
      const res = await fetch('/?section_id=cart-drawer-items');
      if (res.ok) {
        const html = await res.text();
        const container = document.querySelector('[data-cart-items]');
        if (container && html.trim()) {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('[data-cart-items]') || doc.body;
          container.innerHTML = fresh.innerHTML || container.innerHTML;
        }
      }
    } catch (e) { /* items will refresh on next load */ }
  }

  async function addToCart(variantId, qty) {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
    });
    await refreshCart(true);
  }

  async function changeLine(key, quantity) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    await refreshCart(false);
  }

  // ---- Delegated events ----
  document.addEventListener('click', (e) => {
    const openBtn = e.target.closest('[data-cart-open]');
    if (openBtn) { e.preventDefault(); openCart(); return; }

    const closeBtn = e.target.closest('[data-cart-close]');
    if (closeBtn) { e.preventDefault(); closeCart(); return; }

    const add = e.target.closest('[data-add-variant]');
    if (add) {
      e.preventDefault();
      const id = add.dataset.addVariant;
      if (id) addToCart(id, 1);
      return;
    }

    // open variant picker
    const vopen = e.target.closest('[data-variant-open]');
    if (vopen) { e.preventDefault(); openVariant(vopen.dataset.productHandle); return; }
    // close variant picker
    if (e.target.closest('[data-variant-close]')) { e.preventDefault(); closeVariant(); return; }
    // pick an option value
    const vopt = e.target.closest('[data-vm-opt]');
    if (vopt && !vopt.disabled && vmState) {
      vmState.sel[+vopt.dataset.vmOpt] = vopt.dataset.vmVal;
      renderVariantOptions();
      return;
    }
    // confirm add from modal
    const vadd = e.target.closest('[data-vm-add]');
    if (vadd) {
      const id = vadd.dataset.vmVariant;
      if (id) { addToCart(id, 1); closeVariant(); }
      return;
    }

    const up = e.target.closest('[data-qty-up]');
    if (up) { const line = up.closest('[data-line-key]'); bump(line, +1); return; }
    const down = e.target.closest('[data-qty-down]');
    if (down) { const line = down.closest('[data-line-key]'); bump(line, -1); return; }
    const rm = e.target.closest('[data-line-remove]');
    if (rm) { changeLine(rm.dataset.lineRemove, 0); return; }
  });

  function bump(lineEl, delta) {
    if (!lineEl) return;
    const key = lineEl.dataset.lineKey;
    const qtyEl = lineEl.querySelector('.lat');
    const current = parseInt((qtyEl?.textContent || '1').replace(/[٠-٩]/g, d => '٠١٢٣٤٥٦٧٨٩'.indexOf(d))) || 1;
    changeLine(key, Math.max(0, current + delta));
  }

  // Close on Escape
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeCart(); closeVariant(); } });

  /* ===================== Variant picker modal ===================== */
  const vmodal = () => document.getElementById('VariantModal');
  let vmState = null;

  function openVariant(handle) {
    const data = document.querySelector('script[data-variant-data="' + CSS.escape(handle) + '"]');
    if (!data) return;
    let json;
    try { json = JSON.parse(data.textContent); } catch (e) { return; }
    const m = vmodal();
    if (!m) return;

    // thumb
    const thumb = m.querySelector('[data-vm-thumb]');
    if (json.image) {
      thumb.innerHTML = '<div class="ph" style="aspect-ratio:1/1;border-radius:var(--r-sm);background:' + (json.swatch || '#84C341') + ';"><img src="' + json.image + '" style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover;border-radius:var(--r-sm);"></div>';
    } else {
      thumb.innerHTML = '<div class="ph" style="aspect-ratio:1/1;border-radius:var(--r-sm);background:radial-gradient(120% 100% at 30% 18%, rgba(255,255,255,.34), transparent 60%),' + (json.swatch || '#84C341') + ';"></div>';
    }
    m.querySelector('[data-vm-title]').textContent = json.title;

    // option groups
    const sel = json.options.map(o => o.values[0]); // selected value per option position-1
    vmState = { json, sel };
    renderVariantOptions();
    m.classList.add('is-open');
    m.setAttribute('aria-hidden', 'false');
    body.classList.add('modal-open');
  }

  function renderVariantOptions() {
    const m = vmodal(); if (!m || !vmState) return;
    const { json, sel } = vmState;
    const wrap = m.querySelector('[data-vm-options]');
    wrap.innerHTML = json.options.map((opt, oi) => {
      const btns = opt.values.map(val => {
        const active = sel[oi] === val;
        // available if some available variant has this value at this position
        const ok = json.variants.some(v => v.available && v.options[oi] === val);
        return '<button type="button" class="vopt' + (active ? ' is-active' : '') + '"' + (ok ? '' : ' disabled') +
          ' data-vm-opt="' + oi + '" data-vm-val="' + val.replace(/"/g, '&quot;') + '">' + val + '</button>';
      }).join('');
      return '<div class="vmodal__group"><h4>' + opt.name + '</h4><div class="vmodal__opts">' + btns + '</div></div>';
    }).join('');
    updateVariantCta();
  }

  function currentVariant() {
    if (!vmState) return null;
    const { json, sel } = vmState;
    return json.variants.find(v => v.options.every((o, i) => o === sel[i])) || null;
  }

  function updateVariantCta() {
    const m = vmodal(); if (!m || !vmState) return;
    const btn = m.querySelector('[data-vm-add]');
    const v = currentVariant();
    if (v && v.available) {
      btn.disabled = false; btn.style.opacity = '1'; btn.style.cursor = 'pointer';
      btn.innerHTML = 'أضف للسلة · <span class="lat">' + v.price + '</span> ج.م';
      btn.dataset.vmVariant = v.id;
    } else {
      btn.disabled = true; btn.style.opacity = '.5'; btn.style.cursor = 'not-allowed';
      btn.innerHTML = v ? 'غير متاح حاليًا' : 'اختر النوع';
      btn.dataset.vmVariant = '';
    }
  }

  function closeVariant() {
    const m = vmodal();
    if (m) { m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true'); }
    body.classList.remove('modal-open');
    vmState = null;
  }

  /* ===================== Hero slider ===================== */
  function initHeroSliders() {
    document.querySelectorAll('[data-hero-slider]').forEach(root => {
      const slides = [...root.querySelectorAll('[data-hero-slide]')];
      const dots = [...root.querySelectorAll('[data-hero-dot]')];
      if (slides.length > 1) {
        let i = 0;
        const show = (n) => {
          i = (n + slides.length) % slides.length;
          slides.forEach((s, k) => s.classList.toggle('is-active', k === i));
          dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
        };
        let timer = setInterval(() => show(i + 1), 5500);
        const reset = () => { clearInterval(timer); timer = setInterval(() => show(i + 1), 5500); };
        root.querySelector('[data-hero-next]')?.addEventListener('click', () => { show(i + 1); reset(); });
        root.querySelector('[data-hero-prev]')?.addEventListener('click', () => { show(i - 1); reset(); });
        dots.forEach((d, k) => d.addEventListener('click', () => { show(k); reset(); }));
      }
      // reviews rotation
      const reviews = [...root.querySelectorAll('[data-review-item]')];
      const rdots = [...root.querySelectorAll('[data-review-dot]')];
      if (reviews.length > 1) {
        let r = 0;
        const showR = (n) => {
          r = (n + reviews.length) % reviews.length;
          reviews.forEach((it, k) => it.style.display = k === r ? 'block' : 'none');
          rdots.forEach((d, k) => d.classList.toggle('is-active', k === r));
        };
        setInterval(() => showR(r + 1), 6500);
        rdots.forEach((d, k) => d.addEventListener('click', () => showR(k)));
      }
    });
  }
  if (document.readyState !== 'loading') initHeroSliders();
  else document.addEventListener('DOMContentLoaded', initHeroSliders);


  // Intercept product form submit -> AJAX
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[action$="/cart/add"], #product-form');
    if (!form) return;
    e.preventDefault();
    const fd = new FormData(form);
    const id = fd.get('id');
    const qty = parseInt(fd.get('quantity')) || 1;
    if (id) addToCart(id, qty);
  });

  /* ===================== Spending Goals Bar ===================== */

  // Run on page load to show current progress without adding to cart
  async function initGoals() {
    if (!window.sabehGoals || !window.sabehGoals.length) return;
    try {
      const cart = await (await fetch('/cart.js')).json();
      sabehGoalsUpdate(cart);
    } catch (e) { /* silent */ }
  }

  function getGoalLabel(goal) {
    if (goal.label) return goal.label;
    if (goal.type === 'free_shipping') return 'شحن مجاني 🚚';
    if (goal.type === 'free_product') return (goal.productTitle || 'منتج مجاني') + ' 🎁';
    if (goal.type === 'cashback') return 'خصم ' + goal.cashbackPct + '% 💰';
    return 'مكافأة';
  }

  function formatPrice(cents) {
    return (cents / 100).toLocaleString('ar-EG') + ' ج.م';
  }

  async function sabehGoalsUpdate(cart) {
    const goals = window.sabehGoals;
    if (!goals || !goals.length) return;

    const total = cart.total_price;          // in cents
    const max   = window.sabehGoalsMax || goals[goals.length - 1].target;

    // ---- Sticky bar fill ----
    const pct  = Math.min(100, (total / max) * 100);
    const fill = document.getElementById('sgb-fill');
    if (fill) {
      fill.style.width = pct + '%';
      fill.setAttribute('aria-valuenow', Math.round(total / 100));
    }

    // ---- Marker achieved states ----
    document.querySelectorAll('[data-sgb-marker]').forEach(marker => {
      const target = parseInt(marker.dataset.sgbTarget || '0');
      marker.classList.toggle('is-achieved', total >= target);
    });

    // ---- Status message ----
    const nextGoal = goals.find(g => total < g.target);
    const msgEl   = document.getElementById('sgb-msg');
    if (msgEl) {
      if (!nextGoal) {
        msgEl.textContent = '🎉 لقد حصلت على جميع المكافآت!';
      } else {
        const remaining = formatPrice(nextGoal.target - total);
        let msg = '';
        if (nextGoal.type === 'free_shipping') {
          msg = 'فاضلك ' + remaining + ' كمان والتوصيل يبقي مجاني';
        } else if (nextGoal.type === 'free_product') {
          msg = 'فاضل؛ ' + remaining + ' كمان وتاخد ' + (nextGoal.productTitle || 'منتج مجاني') + ' هدية';
        } else if (nextGoal.type === 'cashback') {
          msg = 'فاضلك ' + remaining + ' ويبقي ليك ' + nextGoal.cashbackPct + '% كاش باك على الاوردر الجي';
        }
        msgEl.textContent = msg;
      }
    }

    // ---- Cart drawer milestones ----
    renderCartGoals(cart);

    // ---- Auto-apply / remove free shipping discount code ----
    await syncFreeShipping(cart);

    // ---- Sync free-product rewards (awaited so removal finishes before caller re-renders) ----
    await syncRewardProducts(cart);
  }

  function renderCartGoals(cart) {
    const goals = window.sabehGoals;
    const container = document.getElementById('sgb-cart');
    if (!container || !goals || !goals.length) return;

    const total = cart.total_price;
    const max   = window.sabehGoalsMax || goals[goals.length - 1].target;
    const pct   = Math.min(100, (total / max) * 100);

    const icons = { free_shipping: '🚚', free_product: '🎁', cashback: '💰' };

    // Show only the NEXT unachieved milestone (or the last achieved one if all done)
    const nextGoalObj = goals.find((g, i) => total < g.target);
    const lastAchieved = [...goals].reverse().find(g => total >= g.target);
    const displayGoal  = nextGoalObj || null; // null = all achieved

    let milestonesHtml = '';

    if (!displayGoal) {
      // All milestones achieved
      milestonesHtml = '<div class="sgb-cart__milestone is-achieved">' +
        '<span class="sgb-cart__milestone-icon">🎉</span>' +
        '<span class="sgb-cart__milestone-label">لقد حصلت على جميع المكافآت!</span>' +
        '</div>';
    } else {
      const g         = displayGoal;
      const targetFmt = (g.target / 100).toLocaleString('ar-EG');
      const remaining = formatPrice(g.target - total);

      // Friendly label for this next milestone
      let rowLabel = '';
      if (g.type === 'free_shipping') {
        rowLabel = 'فاضلك ' + remaining + ' كمان والتوصيل يبقي مجاني';
      } else if (g.type === 'free_product') {
        rowLabel = 'فاضل؛ ' + remaining + ' كمان وتاخد ' + (g.productTitle || 'منتج مجاني') + ' هدية';
      } else if (g.type === 'cashback') {
        rowLabel = 'فاضلك ' + remaining + ' ويبقي ليك ' + g.cashbackPct + '% كاش باك على الاوردر الجي';
      }

      milestonesHtml = '<div class="sgb-cart__milestone is-next">' +
        '<span class="sgb-cart__milestone-icon">' + (icons[g.type] || '🎁') + '</span>' +
        '<span class="sgb-cart__milestone-label">' + rowLabel + '</span>' +
        '</div>';

      // If the just-achieved goal is cashback, show the promo code chip below
      if (lastAchieved && lastAchieved.type === 'cashback' && lastAchieved.promoCode) {
        const safeCode = lastAchieved.promoCode.replace(/'/g, "\\'");
        milestonesHtml += '<div class="sgb-cart__milestone is-achieved" style="margin-top:6px;">' +
          '<span class="sgb-cart__milestone-icon">💰</span>' +
          '<span class="sgb-cart__milestone-label">كودك: ' +
            '<button type="button" class="sgb-promo" onclick="navigator.clipboard&&navigator.clipboard.writeText(\'' +
            safeCode + '\').then(()=>{var c=this.querySelector(\'.sgb-promo__copy\');c.textContent=\'تم النسخ ✓\';setTimeout(()=>{c.textContent=\'انسخ\';},2000);})" aria-label="انسخ كود الخصم">' +
            '<span>' + lastAchieved.promoCode + '</span>' +
            '<span class="sgb-promo__copy">انسخ</span>' +
            '</button>' +
          '</span>' +
          '</div>';
      }

      // (free_product reward is visible as a line item in the cart — no extra confirmation needed)
    }

    // ---- Free shipping "applied" confirmation (shown whenever the reward is currently active) ----
    // Checked against the pre-discount subtotal, same basis syncFreeShipping uses, so this
    // stays in sync even while a manual promo code is also affecting cart.total_price.
    const shippingGoal = goals.find(g => g.type === 'free_shipping');
    const shippingBasis = (cart.original_total_price != null ? cart.original_total_price : total);
    if (shippingGoal && shippingBasis >= shippingGoal.target) {
      milestonesHtml += '<div class="sgb-cart__milestone is-achieved" style="margin-top:6px;">' +
        '<span class="sgb-cart__milestone-icon">🚚</span>' +
        '<span class="sgb-cart__milestone-label">التوصيل مجاني مفعّل على طلبك ✓</span>' +
        '</div>';
    }

    container.innerHTML =
      '<div class="sgb-cart__bar">' +
        '<div class="sgb__rail"></div>' +
        '<div class="sgb__fill" style="width:' + pct + '%"></div>' +
        goals.map(g => {
          const mp = Math.min(100, (g.target / max) * 100);
          const achieved = total >= g.target;
          return '<div class="sgb__marker' + (achieved ? ' is-achieved' : '') +
            '" style="left:' + mp + '%;">' +
            '<span class="sgb__marker-icon">' + (icons[g.type] || '🎁') + '</span>' +
            '<div class="sgb__marker-dot"></div>' +
            '</div>';
        }).join('') +
      '</div>' +
      '<div class="sgb-cart__milestones">' + milestonesHtml + '</div>';
  }

  /* ---- Free shipping discount auto-apply ----
     The spending-goals reward always takes priority over any promo code the
     customer typed into the cart drawer themselves. When the cart drops back
     below the threshold, the customer's own code (if any) is restored. */
  let _shippingRewardActive = false;
  let _manualPromoCode = null;

  async function applyCartDiscount(code) {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: code })
    });
    // The /cart/update.js response itself can lag behind on the very first call
    // (its total_price/total_discount sometimes reflect the pre-discount state).
    // A follow-up /cart.js read guarantees the settled totals — the same values
    // you'd see after a page refresh or at checkout — so the drawer never shows
    // a stale, un-discounted total right after applying/removing a code.
    const fresh = await fetch('/cart.js');
    return fresh.json();
  }

  async function syncFreeShipping(cart) {
    const goals = window.sabehGoals;
    if (!goals) return;

    // Find the free-shipping milestone (if any)
    const shippingGoal = goals.find(g => g.type === 'free_shipping');
    if (!shippingGoal) return;

    const code = window.sabehShippingCode || 'FreeDelivery';
    // Use the pre-discount subtotal so the reward can't flicker itself off
    const basis    = (cart.original_total_price != null ? cart.original_total_price : cart.total_price);
    const achieved = basis >= shippingGoal.target;

    if (achieved === _shippingRewardActive) return; // no state change, nothing to do

    try {
      if (achieved) {
        // Reward earned — apply it, overriding any manually-applied promo code
        const fresh = await applyCartDiscount(code);
        _shippingRewardActive = true;
        updateCounts(fresh);
        if (_manualPromoCode) {
          setPromoMsg('التوصيل المجاني مفعّل حاليًا، وهيتطبق كودك تلقائي أول ما ينتهي', false);
        }
        await rerenderDrawer();
      } else {
        // Reward no longer qualifies — restore the customer's own code, if any
        _shippingRewardActive = false;
        const fresh = await applyCartDiscount(_manualPromoCode || '');
        updateCounts(fresh);
        if (_manualPromoCode) {
          const applied = fresh.total_discount > 0;
          setPromoMsg(applied ? 'تم تطبيق الكود بنجاح ✓' : 'الكود غير صالح أو منتهي', applied);
          const btn = document.querySelector('[data-promo-apply]');
          if (btn) { btn.textContent = applied ? 'إزالة' : 'تطبيق'; btn.dataset.mode = applied ? 'remove' : 'apply'; }
        }
        await rerenderDrawer();
      }
    } catch (e) { /* silent — network error won't break the cart */ }
  }

  // Track which reward product keys are currently in cart as rewards
  let _rewardSyncing = false;
  async function syncRewardProducts(cart) {
    const goals = window.sabehGoals;
    if (!goals || _rewardSyncing) return;
    // Use freeVariantId (0-priced variant) if set, otherwise fall back to first available variant
    const freeProductGoals = goals.filter(g => g.type === 'free_product' && (g.freeVariantId || g.productVariant));
    if (!freeProductGoals.length) return;

    _rewardSyncing = true;
    try {
      for (const goal of freeProductGoals) {
        const variantId  = goal.freeVariantId || goal.productVariant;
        const achieved   = cart.total_price >= goal.target;
        // Identify reward items by the hidden line property we stamp on add
        const rewardItems = cart.items.filter(item =>
          item.properties && String(item.properties['_sabeh_reward']) === String(goal.target)
        );
        const alreadyAdded = rewardItems.length > 0;

        if (achieved && !alreadyAdded) {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              items: [{
                id: variantId,
                quantity: 1,
                properties: {
                  '_sabeh_reward': String(goal.target),
                  '_reward_label': goal.productTitle || 'هدية مجانية'
                }
              }]
            })
          });
          // Refresh cart + redraw drawer so item appears immediately
          const fresh = await (await fetch('/cart.js')).json();
          updateCounts(fresh);
          renderCartGoals(fresh);
          await rerenderDrawer();

        } else if (!achieved && alreadyAdded) {
          // Remove reward when cart drops below threshold
          for (const item of rewardItems) {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: item.key, quantity: 0 })
            });
          }
          const fresh = await (await fetch('/cart.js')).json();
          updateCounts(fresh);
          renderCartGoals(fresh);
          await rerenderDrawer();
        }
      }
    } catch (e) { /* silent */ }
    _rewardSyncing = false;
  }

  // Init goals on page load
  if (document.readyState !== 'loading') initGoals();
  else document.addEventListener('DOMContentLoaded', initGoals);

  /* ---- Keep floating corner-actions below the sticky header stack ---- */
  function updateCornerTop() {
    const stack = document.querySelector('.sticky-top');
    if (!stack) return;
    const h = stack.getBoundingClientRect().height;
    document.documentElement.style.setProperty('--sticky-top-h', (h + 10) + 'px');
  }
  if (document.readyState !== 'loading') updateCornerTop();
  else document.addEventListener('DOMContentLoaded', updateCornerTop);
  window.addEventListener('resize', updateCornerTop);

  /* ===================== Order note (cart drawer) ===================== */
  let _noteTimer = null;

  async function saveNote(note) {
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ note })
      });
    } catch (e) { /* silent — note will resend on next edit */ }
  }

  function bindCartNote() {
    const el = document.getElementById('CartNote');
    if (!el || el.dataset.bound) return;
    el.dataset.bound = '1';
    el.addEventListener('input', () => {
      clearTimeout(_noteTimer);
      _noteTimer = setTimeout(() => saveNote(el.value), 600);
    });
    el.addEventListener('blur', () => { clearTimeout(_noteTimer); saveNote(el.value); });
  }
  if (document.readyState !== 'loading') bindCartNote();
  else document.addEventListener('DOMContentLoaded', bindCartNote);

  /* ===================== Promo code (cart drawer) =====================
     Applies the code directly to the cart via the Cart API's `discount`
     param, so the discount amount + new total show immediately in the
     drawer, and the code carries through automatically to checkout. */

  function setPromoMsg(text, ok) {
    const msg = document.querySelector('[data-promo-msg]');
    if (!msg) return;
    msg.textContent = text;
    msg.style.color = ok ? 'var(--brand)' : 'var(--tomato)';
  }

  async function applyPromo(input, btn) {
    const code = input.value.trim();
    if (!code) { setPromoMsg('اكتب كود الخصم الأول', false); return; }

    // The free-shipping reward always wins — remember the code and apply it
    // automatically once the reward is no longer active.
    if (_shippingRewardActive) {
      _manualPromoCode = code;
      setPromoMsg('التوصيل المجاني مفعّل حاليًا، وهيتطبق الكود ده تلقائي أول ما ينتهي', false);
      return;
    }

    btn.disabled = true;
    const prevLabel = btn.textContent;
    btn.textContent = '...';
    try {
      const cart = await applyCartDiscount(code);
      updateCounts(cart);
      await rerenderDrawer();
      if (cart.total_discount > 0) {
        _manualPromoCode = code;
        setPromoMsg('تم تطبيق الكود بنجاح ✓', true);
        btn.textContent = 'إزالة';
        btn.dataset.mode = 'remove';
      } else {
        setPromoMsg('الكود غير صالح أو منتهي', false);
        btn.textContent = prevLabel === '...' ? 'تطبيق' : prevLabel;
        btn.dataset.mode = 'apply';
      }
    } catch (e) {
      setPromoMsg('حصل خطأ، جرب تاني', false);
      btn.textContent = prevLabel === '...' ? 'تطبيق' : prevLabel;
    }
    btn.disabled = false;
  }

  async function removePromo(input, btn) {
    btn.disabled = true;
    _manualPromoCode = null;
    // Only touch the cart's actual discount state if the shipping reward isn't
    // the thing currently occupying it — otherwise there's nothing to remove yet.
    if (!_shippingRewardActive) {
      try {
        const cart = await applyCartDiscount('');
        updateCounts(cart);
        await rerenderDrawer();
      } catch (e) { /* silent */ }
    }
    input.value = '';
    setPromoMsg('', true);
    btn.textContent = 'تطبيق';
    btn.dataset.mode = 'apply';
    btn.disabled = false;
  }

  function bindCartPromo() {
    const btn = document.querySelector('[data-promo-apply]');
    const input = document.getElementById('CartPromo');
    if (!btn || !input || btn.dataset.bound) return;
    btn.dataset.bound = '1';
    // Initial state (applied code / button label / message) is server-rendered
    // from cart.total_discount + cart.cart_level_discount_applications.
    if (btn.dataset.mode === 'remove' && input.value.trim()) {
      _manualPromoCode = input.value.trim();
    }

    btn.addEventListener('click', () => {
      if (btn.dataset.mode === 'remove') removePromo(input, btn);
      else applyPromo(input, btn);
    });
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') { e.preventDefault(); btn.click(); }
    });
  }
  if (document.readyState !== 'loading') bindCartPromo();
  else document.addEventListener('DOMContentLoaded', bindCartPromo);

})();